export * from './VerticalBarChart.styled';
export * from './VerticalBarChart.types';
export { default } from './VerticalBarChart';
